<div *ngIf="displayData" class="summary-donation-content">
  <!-- Summary Container with Border -->
  <div class="summary-donation-content__summary-container">
    <!-- Summary Sections -->
    <div class="summary-donation-content__summary-sections">
      <!-- Donation Details Section -->
      <div class="summary-donation-content__section">
        <h3 class="summary-donation-content__section-heading">
          {{ 'contribute.summary.donation_details' | translateLang }}
        </h3>

        <!-- Country Donating From -->
        <div
          class="summary-donation-row"
          *ngIf="displayData.contributionInfo?.countryDonatingFrom && isSwiss"
        >
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.country_donating_from' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.contributionInfo.countryDonatingFrom.name | lowercase | titlecase }}
          </span>
        </div>

        <!-- Tax Deductions -->
        <div
          class="summary-donation-row"
          *ngIf="displayData.contributionInfo?.taxDeduction !== null"
        >
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.tax_deductions' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ taxDeduction }}
          </span>
        </div>

        <!-- Fund -->
        <div class="summary-donation-row">
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.fund' | translateLang }}
          </span>
          <span class="summary-donation-row__value summary-donation-row__value--bold">
            {{ summaryFundName | fundNameFormat }}
          </span>
        </div>

        <!-- Contribution Type -->
        <div class="summary-donation-row">
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.contribution_type' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ contributionTypeText | translateLang }}
          </span>
        </div>

        <!-- DAF Provider -->
        <div class="summary-donation-row" *ngIf="displayData.dafProvider">
          <span class="summary-donation-row__label">
            {{ 'donate.summary.labels.daf.provider' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.dafProvider | translateLang }}
          </span>
        </div>

        <!-- Fund Name -->
        <div class="summary-donation-row" *ngIf="displayData.fundName">
          <span class="summary-donation-row__label">
            {{ 'donate.summary.labels.fund.name' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.fundName | translateLang }}
          </span>
        </div>

        <!-- Asset Description -->
        <div class="summary-donation-row" *ngIf="displayData.assetDescription">
          <span class="summary-donation-row__label">
            {{ 'donate.contribution.labels.asset.description' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.assetDescription | translateLang }}
          </span>
        </div>

        <!-- Amount -->
        <div class="summary-donation-row">
          <span class="summary-donation-row__label">
            {{
              (displayData.contributionType === contributionTypes.PUBLICLY_TRADED_SECURITIES
                ? 'donate.contribution.labels.est.amount'
                : 'contribute.summary.amount'
              ) | translateLang
            }}
          </span>
          <span *ngIf="!isSwiss; else swiss" class="summary-donation-row__value">
            {{
              displayData.financialInfo.amount
                | currency
                  : displayData.financialInfo.currency.symbol || displayData.financialInfo.currency
                  : 'symbol'
                  : '1.2-2'
                | numberFormat
            }}
          </span>
          <ng-template #swiss>
            <span class="summary-donation-row__value">
              {{
                displayData.financialInfo.amount
                  | currency : displayData.financialInfo.currency.symbol : 'symbol' : '1.2-2'
                  | numberFormat
              }}
            </span>
          </ng-template>
        </div>

        <!-- Anonymous -->
        <div class="summary-donation-row">
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.anonymous' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ (displayData.financialInfo.anonymousDonation ? 'Yes' : 'No') | translateLang }}
          </span>
        </div>

        <!-- Contribution Purpose -->
        <div class="summary-donation-row">
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.contribution_purpose' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.financialInfo.contributionPurpose }}
          </span>
        </div>

        <!-- Recurrence Pattern -->
        <div class="summary-donation-row" *ngIf="displayData.recurrencePattern">
          <span class="summary-donation-row__label">
            {{ 'summary.recurrence.pattern' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{
              'donate.recurring.contribution.labels.pattern.' + (displayData.recurrencePattern | lowercase)
                | translateLang
            }}
          </span>
        </div>

        <!-- Start Date -->
        <div class="summary-donation-row" *ngIf="displayData.startDate">
          <span class="summary-donation-row__label">
            {{ 'summary.contribution.start.date' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.startDate | date : dateFormat }}
          </span>
        </div>

        <!-- End Date -->
        <div class="summary-donation-row" *ngIf="displayData.endDate">
          <span class="summary-donation-row__label">
            {{ 'summary.contribution.end.date' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.endDate | date : dateFormat }}
          </span>
        </div>
      </div>

      <!-- Section Divider -->
      <div class="summary-donation-content__section-divider"></div>

      <!-- Giver Information Section -->
      <div class="summary-donation-content__section">
        <h3 class="summary-donation-content__section-heading">
          {{ 'contribute.summary.giver_information' | translateLang }}
        </h3>

        <!-- Company Name -->
        <div class="summary-donation-row" *ngIf="displayData.giverInfo.companyName">
          <span class="summary-donation-row__label">
            {{ 'summary.company.name' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.giverInfo.companyName }}
          </span>
        </div>

        <!-- First Name -->
        <div class="summary-donation-row">
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.first_name' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.giverInfo.firstName }}
          </span>
        </div>

        <!-- Middle Name -->
        <div class="summary-donation-row" *ngIf="displayData.giverInfo.middleName">
          <span class="summary-donation-row__label">
            {{ 'summary.middle.name' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.giverInfo.middleName }}
          </span>
        </div>

        <!-- Last Name -->
        <div class="summary-donation-row">
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.last_name' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.giverInfo.lastName }}
          </span>
        </div>

        <!-- Email -->
        <div class="summary-donation-row">
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.email' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.giverInfo.email }}
          </span>
        </div>

        <!-- Address -->
        <div class="summary-donation-row">
          <span class="summary-donation-row__label">
            {{ 'contribute.summary.address' | translateLang }}
          </span>
          <span class="summary-donation-row__value">
            {{ displayData.giverInfo.streetAddress }}, {{ displayData.giverInfo.city }},
            <span *ngIf="displayData.giverInfo.stateProvince"
              >{{ displayData.giverInfo.stateProvince }},</span
            >
            {{ displayData.giverInfo.country.name || displayData.giverInfo.country }},
            {{ displayData.giverInfo.postalCode }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Portal toast container -->
<app-toast />
